export const CartPath = '/cart';
export const CheckoutReviewPath = '/checkout/review';
export const CheckoutSuccessPath = {
  path: '/checkout/success',
  withIds: (ids: string[], supplierIds: string[]): string => {
    const idParams = ids.map((id) => `id=${encodeURIComponent(id)}`).join('&');
    const supplierIdParams = supplierIds
      .map((supplierId) => `supplierId=${encodeURIComponent(supplierId)}`)
      .join('&');
    const queryParams = [idParams, supplierIdParams].filter((param) => param).join('&');
    return `${CheckoutSuccessPath.path}?${queryParams}`;
  },
};
export const ShopPath = {
  path: '/shop',
  withSupplierId(supplierId: string): string {
    return ShopPath.path + `?supplierId=${supplierId}`;
  },
};
export const ProductDetailsPath = {
  path: '/shop/products/:skuId',
  withId(id: string): string {
    return ProductDetailsPath.path.replace(':skuId', id);
  },
};
export const StoreSettingsPath = {
  profile: '/settings/profile',
  address: '/settings/address',
  businessAddress: '/settings/business-address',
  deliveryAddress: '/settings/delivery-address',
  currency: '/settings/currency',
  language: '/settings/language',
  notification: '/settings/notifications',
  password: '/settings/password',
  supplier: '/settings/suppliers',
};
export const SettingsSupplierAddPath = '/settings/supplier/add';
export const SettingsSupplierEditPath = {
  path: '/settings/supplier/:supplierId',
  withId: (supplierId: string): string => {
    return SettingsSupplierEditPath.path.replace(':supplierId', supplierId);
  },
};
